import React from "react";
import transform1 from "../assets/images/transform1.png";
import transform2 from "../assets/images/transform2.png";
import transform3 from "../assets/images/transform3.jpeg";

function StepCard({ n, img, title, text }) {
  return (
    <div className="flex flex-col items-center text-center max-w-xs mx-auto">
      <div className="relative isolate">
        <img
          src={img}
          alt={title}
          className="rounded-full object-cover ring-[14px] ring-[#9AEEDA] ring-offset-white w-40 h-40 sm:w-48 sm:h-48 md:w-56 md:h-56 lg:w-60 lg:h-60"
        />
        <span
          className="absolute -top-2 -left-2 flex items-center justify-center rounded-full bg-[#9AEEDA] text-white font-bold font-century ring-[5px] ring-[#9AEEDA] ring-opacity-50 w-10 h-10 text-xl sm:w-12 sm:h-12 sm:text-2xl z-10"
        >
          {n}
        </span>
      </div>
      <div className="text-left pl-2 sm:pl-4">
        <h3 className="mt-6 font-century font-bold text-base sm:text-lg md:text-xl">{title}</h3>
        <p className="font-roboto font-normal text-sm sm:text-base">{text}</p>
      </div>
    </div>
  );
}

export default function Transform() {
  const steps = [
    {
      img: transform1,
      title: "Commit to Your Transformation",
      text: "Let go of diets built on restriction and control. This retreat helps you uncover and heal what’s really driving your relationship with food. Say yes to a path that leads to deep, lasting freedom—from the inside out.",
    },
    {
      img: transform2,
      title: "Do the Work with Us",
      text: "Through guided sessions, you’ll learn to let go of the inner critic and connect with your true self, free from compulsive behaviors.",
    },
    {
      img: transform3,
      title: "Embrace Lasting Freedom",
      text: "You’ll leave the retreat empowered with real tools and the support of a community that keeps you connected. This journey is about learning how to care for yourself fully, deeply, and with love.",
    },
  ];

  return (
    <section className="py-6 sm:py-10 px-4 sm:px-8 bg-white">
      <h2 className="font-century text-2xl sm:text-3xl md:text-4xl text-left pb-6 sm:pb-10 pl-4 sm:pl-16">
        Transform Your Relationship with Food and Yourself
      </h2>
      <div className="grid gap-10 sm:gap-12 md:gap-16 md:grid-cols-2 lg:grid-cols-3">
        {steps.map((s, i) => (
          <StepCard key={i} n={i + 1} {...s} />
        ))}
      </div>
    </section>
  );
}